import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmissiononboardingPopupComponent } from './emissiononboarding-popup.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [EmissiononboardingPopupComponent],
  imports: [CommonModule, ReactiveFormsModule, MatIconModule],
})
export class EmissiononboardingPopupModule {}
